import React from 'react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: '住宅設計',
      icon: 'home',
      image: require('../images/service-1.jpg')
    },
    {
      id: 2,
      title: '透天大宅',
      icon: 'building',
      image: require('../images/service-2.jpg')
    },
    {
      id: 3,
      title: '中古屋翻新',
      icon: 'tools',
      image: require('../images/service-3.jpg')
    },
    {
      id: 4,
      title: '辦公室空間',
      icon: 'briefcase',
      image: require('../images/service-4.jpg')
    },
    {
      id: 5,
      title: '商業空間',
      icon: 'store',
      image: require('../images/service-5.jpg')
    },
    {
      id: 6,
      title: '局部裝修',
      icon: 'hammer',
      image: require('../images/service-6.jpg')
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-container">
        <div className="services-header">
          <h2 className="section-title">服務項目</h2>
        </div>
        <div className="services-grid">
          {services.map(service => (
            <div className="service-item" key={service.id}>
              <div className="service-icon">
                <div className="icon-container">
                  <span className={`service-icon-${service.icon}`}></span>
                </div>
                <h3 className="service-title">
                  {/* <span className="item-number">ITEM {String(service.id).padStart(2, '0')}</span> */}
                  <span className="item-title">{service.title}</span>
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services; 